import { Link } from "react-router-dom";

export default function Footer({ settings, base = "" }) {
  const nav = settings?.nav || [];
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-ink/10 bg-parchment" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 sm:px-12 lg:px-20 py-16 grid gap-12 md:grid-cols-3">
        <div>
          <p className="font-serif text-2xl font-bold text-ink">{settings?.brand_name || "Chef Blaine Guillot"}</p>
          <p className="mt-2 text-xs uppercase font-mono tracking-[0.25em] text-brass2">{settings?.tagline}</p>
          <p className="mt-5 text-sm text-ink2 leading-relaxed max-w-sm">{settings?.footer_text}</p>
        </div>
        <div>
          <p className="text-xs uppercase font-mono tracking-[0.25em] text-brass2 mb-5">Explore</p>
          <div className="flex flex-col gap-3">
            {nav.map((item, i) => (
              <Link key={i} to={item.slug === "home" ? `${base}/` : `${base}/${item.slug}`} data-testid={`footer-link-${item.slug}`} className="text-sm text-ink2 hover:text-brass2 transition-colors w-fit">
                {item.label}
              </Link>
            ))}
          </div>
        </div>
        <div>
          <p className="text-xs uppercase font-mono tracking-[0.25em] text-brass2 mb-5">Associations</p>
          {settings?.association_logos?.length ? (
            <div className="flex flex-wrap items-center gap-6">
              {settings.association_logos.map((logo, i) => (
                <img key={i} src={logo} alt={`Association logo ${i + 1}`} className="h-10 w-auto object-contain opacity-70 hover:opacity-100 transition-opacity" data-testid={`assoc-logo-${i}`} />
              ))}
            </div>
          ) : (
            <div className="flex flex-wrap gap-3">
              {(settings?.associations || []).map((a, i) => (
                <span key={i} className="rounded-full border border-ink/15 px-4 py-1.5 text-xs font-mono text-ink2">{a}</span>
              ))}
            </div>
          )}
          {settings?.phone && <p className="mt-6 text-sm text-ink2">{settings.phone}</p>}
          {settings?.email && <p className="mt-1 text-sm text-ink2">{settings.email}</p>}
        </div>
      </div>
      <div className="border-t border-ink/10 py-6 text-center text-xs text-ink2/60 font-mono tracking-wider">
        © {year} {settings?.brand_name || "Chef Blaine Guillot"}. South Louisiana, with love.
      </div>
    </footer>
  );
}
